import { SacChamado } from "@/types/Chamados";
import { useEffect, useState } from "react";
import ChamadoHistoricoDetail from "./ChamadoHistoricoDetail";
import ChamadosHistoricoList from "./ChamadosHistoricoList";

export default function ChamadosHistoricoManager() {
  const [selectedChamado, setSelectedChamado] = useState<SacChamado | null>(
    null
  );

  // Scroll suave para o topo quando selecionar/desselecionar chamado
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [selectedChamado]);

  const handleBack = () => {
    setSelectedChamado(null);
  };

  if (selectedChamado) {
    return (
      <ChamadoHistoricoDetail chamado={selectedChamado} onBack={handleBack} />
    );
  }

  return <ChamadosHistoricoList onSelectChamado={setSelectedChamado} />;
}
